module.exports = __webpack_public_path__ + "img/970205203_1200.80bb3b9a.jpg";